import { render, staticRenderFns } from "./boards_menu_collapse.vue?vue&type=template&id=3a8b86ba&scoped=true&"
import script from "./boards_menu_collapse.vue?vue&type=script&lang=js&"
export * from "./boards_menu_collapse.vue?vue&type=script&lang=js&"
import style0 from "./boards_menu_collapse.vue?vue&type=style&index=0&id=3a8b86ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b86ba",
  null
  
)

export default component.exports